
<div class="printfooter">
  <div class="row margin-left-0px margin-right-0px">
    
    <div class="col-print-12">
      <label class="margin-bottom-0px font-family">Cashier</label>
    </div>
  </div>
  <div class="row margin-left-0px margin-right-0px">
    <div class="col-print-6">
      <label class="margin-bottom-0px font-family"></label>
    </div>
    <div class="col-print-6">
      <label class="margin-bottom-0px font-family"></label>
    </div>
  </div>
  <div class="row margin-left-0px margin-right-0px">    
    <div class="col-print-3">
      <div class="row margin-left-0px margin-right-0px">
        <div class="col-print-8 border-bot-1px">
          <label class="margin-bottom-0px font-family"></label>
        </div>
        <div class="col-print-4">
          <label class="margin-bottom-0px font-family"></label>
        </div>
      </div>
    </div>
  </div>
  <div class="row margin-left-0px margin-right-0px">
    <div class="col-print-6">
      <label class="margin-bottom-0px font-family"></label>
    </div>
    <div class="col-print-6">
      <label class="margin-bottom-0px font-family"></label>
    </div>
  </div>
  <div class="card bordertop">
    
    <div class="card-header border-bottom-0px">

    </div>
    <div class="card-body padding-top-0px padding-bottom-0px">
      <div class="row">
        <div class="col-print-9">

        </div>
        <div class="col-print-3">
          <label class="margin-bottom-0px font-family13px">Print Taken: {{Date | date:'dd-MMM-yyyy'}}</label>
        </div>
      </div>
      <div class="row">
        <div class="col-print-9">

        </div>
        <div class="col-print-3">
          <label class="margin-bottom-0px font-family13px">Page No: 1 of 1</label>
        </div>
      </div>
    </div>


    <!--<div class="row">
      <div class="col-md-4">
        <label class="margin-bottom-0px font-family">Print Taken On:</label>
      </div>
      <div class="col-md-6">
        <label class="margin-bottom-0px font-family float-left">{{Date | date:'dd-MMM-yyyy'}}</label>
      </div>
    </div>-->
  </div>

</div>

